module.exports = __webpack_public_path__ + "img/schnittkante_weiss_candy.8a82bb21.jpg";